<template>
    <div class="card nch--cart">
        <h1 class="px-3 py-2 mb-0">
            <i class="mdi mdi-credit-card mr-3"></i>
            {{$t('financial.deposit.title')}}
        </h1>
        <div class="deposit-content p-4">
            <div class="my-3" v-html="order.invoice.gateway.deposit_description"></div>
            <div class="d-flex flex-wrap align-items-center">
                <div
                    class="d-flex col-12 col-md-6 justify-content-center justify-content-md-start"
                    v-if="order.attachment"
                >
                    <a class="receipt" :href="url()" target="_blank" download>
                        <i class="mdi mdi-paperclip">{{$t('common.receipt')}}</i>
                    </a>
                </div>
                <base-button type="success" @click="modal=true">
                    <span class="mdi mdi-paperclip">{{$t('common.attach')}}</span>
                </base-button>
                <span v-if="attached">{{$t('financial.invoices.attachment_success')}}</span>

                <UploadDropzoneModal
                    :modal="modal"
                    @close="modal=false"
                    @success="onSuccess"
                    v-model="file"
                ></UploadDropzoneModal>
            </div>
        </div>
    </div>
</template>

<script>
import UploadDropzoneModal from "../Common/Upload/UploadDropzoneModal";
import BaseButton from "../../argon/components/BaseButton";

export default {
    name: "DepositAttachment",

    components: {
        UploadDropzoneModal,
        BaseButton
    },

    props: {
        modelValue: Object,
        value: Object,
        invoiceId: Number
    },

    data() {
        return {
            buttonLoading: false,
            file: [],
            modal: false,
            attached: false
        };
    },

    computed: {
        changeCol() {
            if (this.order.attachment) {
                return "col-12 col-md-6";
            } else return "col-12";
        },
        order: {
            get() {
                return this.modelValue !== undefined ? this.modelValue : this.value;
            },
            set(value) {
                this.$emit("update:modelValue", value);
                this.$emit("input", value);
            }
        }
    },

    methods: {
        onSuccess(file) {
            this.file = file;
            this.saveAttachment();
            this.modal = false;
            this.attached = true;
        },

        url() {
            return this.image(this.order.attachment, 'original');
        },

        saveAttachment() {
            window.axios
                .post(`/api/app/invoices/${this.invoiceId}/attachment`, {
                    attachment: {
                        ...this.file,
                        status: 1,
                        author_id: this.order.invoice.student_id
                    }
                })
                .then(res => {
                    this.$notify({
                        type: "success",
                        message: res.data.message
                    });
                })
                .catch(err => console.error(err));
        }
    }
};
</script>

<style>
</style>
